import i18n from 'i18next'
import store from '../store'
import axios from 'axios'
import MAAYOT_API, { headers } from '../../utils/config'
import {
  MANAGE_WORDLIST_LOADER,
  SET_ALL_LANGUAGE,
  SET_LEARN_ABOUT,
  SET_LEARN_ABOUT_LOADING,
  SET_LEARN_ABOUT_TITLE,
  SET_LOADER_RECOMMENDED,
  SET_STEPPER_STEP,
  SET_WORD_RESULT,
} from '../types'
import axiosInstance from '../../axios/axiosInstance'
import {
  GetLearnAboutMaayotTitleProps,
  GetRecommendedProps,
  GetWordListProps,
  NoKnownWordProps,
  NotLearnedLanguageProps,
} from '../../types/global'

export const getWordsList = async (data: GetWordListProps) => {
  try {
    store.dispatch({ type: MANAGE_WORDLIST_LOADER, payload: true })
    const res = await axiosInstance.post(`language-dictionary/getRandomWords`, data)
    store.dispatch({ type: MANAGE_WORDLIST_LOADER, payload: false })
    return res?.data
  } catch (error: any) {
    if (error?.response?.data.statusCode === 400) {
      store.dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      window.location.href = '/'
      return
    }
    store.dispatch({ type: MANAGE_WORDLIST_LOADER, payload: false })
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const getLearnAboutMaayot = async () => {
  try {
    store.dispatch({ type: SET_LEARN_ABOUT_LOADING, payload: true })
    const res = await axiosInstance.get(`user-language/how-learn-about-maayot`)
    store.dispatch({ type: SET_LEARN_ABOUT_LOADING, payload: false })
    store.dispatch({ type: SET_LEARN_ABOUT, payload: res?.data?.data || [] })
    return res?.data
  } catch (error: any) {
    if (error?.response?.data.statusCode === 400) {
      store.dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      window.location.href = '/'
      return
    }
    store.dispatch({ type: SET_LEARN_ABOUT_LOADING, payload: false })
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const getLearnAboutMaayotTitle = async (data: GetLearnAboutMaayotTitleProps) => {
  try {
    const res = await axiosInstance.post(`user-language/learn-about-maayot-question`, data)
    store.dispatch({ type: SET_LEARN_ABOUT_TITLE, payload: res.data.data })
    return res?.data
  } catch (error: any) {
    if (error?.response?.data.statusCode === 400) {
      store.dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      window.location.href = '/'
      return
    }
    store.dispatch({ type: SET_LEARN_ABOUT_TITLE, payload: '' })
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const noKnownWord = async (data: NoKnownWordProps) => {
  try {
    const res = await axios.post(`${MAAYOT_API}language-dictionary/notKnownWord`, data, {
      headers,
    })

    return res?.data
  } catch (error) {
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const notLearnedLanguage = async (data: NotLearnedLanguageProps) => {
  try {
    const res = await axiosInstance.post(`language-dictionary/notLearnedLanguage`, data)
    return res?.data
  } catch (error: any) {
    if (error?.response?.data.statusCode === 400) {
      store.dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      window.location.href = '/'
      return
    }
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const getAllLanguage = async () => {
  try {
    const response = await axios.get(`${MAAYOT_API}language/get/all`, {
      headers,
    })
    store.dispatch({ type: SET_ALL_LANGUAGE, payload: response?.data?.data })
    return response?.data?.data
  } catch (error) {
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

export const getScore = async (data: NotLearnedLanguageProps) => {
  try {
    const response = await axiosInstance.post(`language-dictionary/getScore`, data)
    store.dispatch({ type: SET_WORD_RESULT, payload: response?.data?.data?.finalScore })
    return response?.data?.data
  } catch (error: any) {
    if (error?.response?.data.statusCode === 400) {
      store.dispatch({ type: SET_STEPPER_STEP, payload: 1 })
      window.location.href = '/'
      return
    }
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}

// --- Adaptive reading placement test (anonymous, temp-user based) ---

export const getPlacementExams = async (languageId: string) => {
  try {
    const res = await axios.get(`${MAAYOT_API}placement/exams`, { params: { language_id: languageId }, headers })
    return res?.data?.data || []
  } catch (error) {
    return []
  }
}

export const getPlacementExcerpt = async (data: {
  language_id: string
  preference_id?: string
  temp_user?: string
  exam_band_id?: string
  learning_goal?: string
  restart?: boolean
}) => {
  try {
    const res = await axios.post(`${MAAYOT_API}placement/excerpt`, data, { headers })
    return res?.data?.data
  } catch (error) {
    return null
  }
}

export const submitPlacementPassage = async (data: {
  temp_user: string
  story_id: string
  words: { dict_id: string; frequency: number | null; known: boolean }[]
  rating: 'easy' | 'ok' | 'hard'
}) => {
  try {
    const res = await axios.post(`${MAAYOT_API}placement/passage`, data, { headers })
    return res?.data?.data
  } catch (error) {
    return null
  }
}

export const saveAttribution = async (data: {
  how_learn_about_maayot?: string
  learn_about_question?: string
  learn_about_answer?: string
}) => {
  try {
    const res = await axiosInstance.patch(`user-language/attribution`, data)
    return res?.data
  } catch (error) {
    return null
  }
}

export const getRecommended = async (data: GetRecommendedProps) => {
  try {
    store.dispatch({ type: SET_LOADER_RECOMMENDED, payload: true })
    const response = await axiosInstance.post(`words/text-recomendation`, data)
    store.dispatch({ type: SET_LOADER_RECOMMENDED, payload: false })
    return response?.data?.data
  } catch (err: any) {
    store.dispatch({ type: SET_LOADER_RECOMMENDED, payload: false })
    return { status: 404, message: i18n.t('common:somethingWentWrong') }
  }
}
